import "core-js/modules/es.array.map.js";
import React from 'react';
import { useLocation } from 'react-router';
import { useGetSharingPermissions } from 'screens/ShareModal';
import MultiAssetHeader from './MultiAssetHeader';
import MultiAssetDetailsPage from './MultiAssetDetailsPage';
import { useGetTabInfo } from '../useGetTabInfo';
function MultiAssetManager(_ref) {
  var titleId = _ref.titleId,
    assets = _ref.assets,
    parentPlaylistId = _ref.parentPlaylistId,
    getIsActiveTab = _ref.getIsActiveTab,
    getTabLink = _ref.getTabLink,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var location = useLocation();
  var _useGetSharingPermiss = useGetSharingPermissions({
      contentIds: assets.map(function (asset) {
        return asset.id;
      }),
      contentParentPlaylistId: parentPlaylistId
    }),
    shareData = _useGetSharingPermiss.shareData;
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getTabLink,
      getIsActiveTab: getIsActiveTab,
      location: location,
      tabs: ['details']
    }),
    tabLinks = _useGetTabInfo.tabLinks;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MultiAssetHeader, {
    titleId: titleId,
    assets: assets,
    onClose: onClose,
    shareData: shareData,
    tabLinks: tabLinks
  }), /*#__PURE__*/React.createElement(MultiAssetDetailsPage, {
    initialAssetDetailItems: assets,
    onSubmit: onSubmit,
    onClose: onClose
  }));
}
export default MultiAssetManager;